import { render } from "./DatosOficioResolutivo.vue?vue&type=template&id=436c9725"
import script from "./DatosOficioResolutivo.vue?vue&type=script&lang=js"
export * from "./DatosOficioResolutivo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__